"use client";
import React from "react";
import AboutOverview from "@/components/about/AboutOverview";
import WhyUs from "@/components/about/WhyUs";
import Mision from "@/components/about/Mision";
import Directors from "@/components/about/Directors";
import AwardSlider from "@/components/about/AwardSlider";
import InnerBanner from "@/components/common/InnerBanner";
import Address from "@/components/contact/Address";
import ContactPageForm from "@/components/common/forms/ContactPageForm";

const ContactSectionRenderer = ({ item, index, getAddress }) => {
    switch (item?.section_data?.template) {
        case 'innerbanner':
            return (
                <React.Fragment key={index}>
                    <InnerBanner  img={item?.images?.list?.[0]?.full_path} title={item?.section_data?.subtitle} text={item?.section_data?.short_desc}/>
                </React.Fragment>
            );
        case 'contact_address':
            return (
                <React.Fragment key={index}>
                    <Address data={getAddress}/>
                </React.Fragment>
            );
        case 'maximax_form':
            return (
                <React.Fragment key={index}>
                    <ContactPageForm data={item}/>
                </React.Fragment>
            );
        default:
            return null; // If the template doesn't match any case, render nothing
    }
};

export default React.memo(ContactSectionRenderer);
